<template>
  <v-card class="mx-auto" max-width="100%" flat>
    <v-img
      height="100%"
      src="@/assets/images/CardBackground.jpg"
      gradient="to top right, rgb(255,255,255,1.5), rgba(255,255,255,.9)"
    >
      <v-row align="end" class="fill-height">
        <v-col
          align-self="center"
          style="padding-bottom: 0px"
          cols="12"
          sm="4"
          md="4"
          lg="4"
          class="pr-1"
        >
          <v-avatar
            color="Neutral lighten-1"
            height="199"
            width="100%"
            max-width="150"
            tile
          >
            <v-img
              v-if="item.profilePhoto"
              :src="item.profilePhoto"
              height="199"
              width="100%"
            ></v-img>
            <v-img v-else src="@/assets/images/No-Photo.jpg"></v-img>
          </v-avatar>
        </v-col>
        <v-col align-self="start" cols="12" sm="8" md="8" lg="8" class="pb-1 pr-1 pl-1">
          <v-card flat tile>
            <v-list dense>
              <v-list-item
                style="align-items: start; padding: 0px; min-height: 20px"
              >
                <v-tooltip bottom v-if="item.registered_email.length > 37">
                  <template v-slot:activator="{ on, attrs }">
                    <v-chip
                      v-bind="attrs"
                      v-on="on"
                      small
                      class="py-0 pl-2"
                      label
                      style="
                        background-color: transparent !important;
                        height: auto;
                      "
                    >
                      <v-icon small left color="primary" class="mt-1">
                        mdi-email
                      </v-icon>
                      <strong class="text-truncate">
                        {{ item.registered_email }}</strong
                      >
                    </v-chip>
                  </template>
                  <span>{{ item.registered_email }}</span>
                </v-tooltip>
                <v-chip
                  v-else
                  small
                  class="py-0 pl-2"
                  label
                  style="background-color: transparent !important; height: auto"
                >
                  <v-icon small left color="primary" class="mt-1">
                    mdi-email
                  </v-icon>
                  <strong class="text-truncate">
                    {{ item.registered_email }}
                  </strong>
                </v-chip>
              </v-list-item>
              <v-divider class="mt-1"></v-divider>
              <v-row class="mt-0">
                <v-col cols="12" sm="6" md="6" class="pl-0 pr-0 pt-2">
                  <v-list-item style="align-items: start; padding: 0px; min-height: 15px">
                    <v-tooltip allow-overflow top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          small
                          class="py-0"
                          label
                          v-bind="attrs"
                          v-on="on"
                          style="background-color: transparent !important"
                        >
                          <strong class="pr-1">
                            {{ $t("statistics.lblAttendanceRate") }}:
                          </strong>
                          {{ Number(getAttendance(item.attendanceData)) }}%
                        </v-chip>
                      </template>
                      <span v-html="$t('statistics.tooltipAttendanceRate')"></span>
                    </v-tooltip>
                  </v-list-item>
                  <v-list-item
                    style="align-items: start; padding: 0px; min-height: 15px"
                  >
                    <v-chip
                      small
                      class="py-0"
                      label
                      style="background-color: transparent !important"
                    >
                      <strong class="pr-1">{{ $t("statistics.lblInvited") }}:</strong>
                      {{ item.attendanceData.invited }}
                    </v-chip>
                  </v-list-item>
                  <v-list-item
                    style="align-items: start; padding: 0px; min-height: 15px"
                  >
                    <v-chip
                      small
                      class="py-0"
                      label
                      style="background-color: transparent !important"
                    >
                     <strong class="pr-1"> {{ $t("statistics.lblAttended") }}:</strong>
                      {{ item.attendanceData.attended }}
                    </v-chip>
                  </v-list-item>

                  <v-list-item
                    style="align-items: start; padding: 0px; min-height: 15px"
                  >
                    <v-chip
                      small
                      class="py-0"
                      label
                      style="background-color: transparent !important"
                    >
                     <strong class="pr-1"> {{ $t("statistics.lblRemote") }}:</strong>
                      {{ item.attendanceData.remote }}
                    </v-chip>
                  </v-list-item>
                  <v-list-item
                    style="align-items: start; padding: 0px; min-height: 15px"
                  >
                    <v-chip
                      small
                      class="py-0"
                      label
                      style="background-color: transparent !important"
                    >
                     <strong class="pr-1"> {{ $t("statistics.lblAbsent") }}:</strong>
                      {{ item.attendanceData.absent }}
                    </v-chip>
                  </v-list-item>
                </v-col>
                <v-col cols="12" sm="6" md="6" class="pl-0 pt-2">
                  <attendance-analysis-chart :item="item">
                  </attendance-analysis-chart>
                </v-col>
                <v-col cols="12" sm="12" md="12" class="pa-0">
                  <v-divider class="ml-3"></v-divider>
                  <v-list-item
                    style="align-items: start; padding: 0px; min-height: 15px"
                  >
                    <v-chip
                      small
                      class="py-0"
                      label
                      style="background-color: transparent !important"
                    >
                     <strong class="pr-1"> {{ $t("statistics.lblInWriting") }}:</strong>
                      {{ item.attendanceData.in_writing }}
                    </v-chip>
                  </v-list-item>
                </v-col>
              </v-row>
            </v-list>
          </v-card>
        </v-col>

        <v-col class="py-0">
          <v-list-item color="rgba(0, 0, 0, .4)" class="primary-gradient" dark>
            <v-list-item-content
              style="
                padding-top: 5px;
                padding-bottom: 16px;
                min-height: 55px;
                vertical-align: top;
              "
            >
              <v-list-item-title class="subtitle-2">
                <span v-if="item.firstName">{{
                  item.firstName + " " + item.lastName
                }}</span>
                <span v-else>{{ item.registered_email }}</span>
              </v-list-item-title>
              <v-list-item-subtitle class="caption" v-show="item.title">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">{{ item.title }}</span>
                  </template>
                  <span>{{ item.title }}</span>
                </v-tooltip>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
      </v-row>
    </v-img>
  </v-card>
</template>

<script>
import AttendanceAnalysisChart from "./AttendanceAnalysisChart.vue";
export default {
  components: { AttendanceAnalysisChart },
  name: "UserCard",
  props: {
    item: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      isDialogOpen: false,
    };
  },
  computed: {},
  methods: {
    getAttendance(data) {
      let attended = Number(data.attended);
      let attendance;
      if (data.invited > 0) {
        attendance = (Number(attended) / Number(data.invited)) * 100;
      } else {
        attendance = 0;
      }
      return attendance.toFixed(0);
    },
  },
};
</script>

<style scoped>
.primary-gradient {
  color: white !important;
  background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0) 0%,
      rgba(0, 0, 0, 0.08) 100%
    ),
    #006cad !important;
  font-weight: 700 !important;
}
::v-deep .surveydates {
  font-size: smaller !important;
  color: gray;
}

.title-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  line-height: 1.5 !important;
}
</style>
